import React, { useState } from "react";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { Check, GraduationCap, Clock, BadgeCheck } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";
import { COURSES, ACADEMY_PERKS, IMAGES } from "@/data/content";

export default function Academy() {
  const [active, setActive] = useState(COURSES[0]);
  return (
    <>
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0"><img src={IMAGES.academy} alt="" className="w-full h-full object-cover opacity-30" /><div className="absolute inset-0 bg-gradient-to-b from-midnight/70 to-midnight" /></div>
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <Label>Spunky Scissors Academy</Label>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">Turn Your Passion Into a <span className="gold-shimmer italic">Profession.</span></h1>
          <p className="text-lg text-white/75 mt-6 max-w-2xl mx-auto">Certified, career-focused beauty education with EMI options, internships & real placement assistance.</p>
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {ACADEMY_PERKS.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}><div className="glass rounded-lg p-5 flex items-center gap-3 transition-colors duration-500"><BadgeCheck className="text-gold shrink-0" size={20} /><span className="text-sm text-white/85">{p}</span></div></Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle label="Our Programs" title="Professional Courses" />
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {COURSES.map((c) => (
            <button key={c.id} onClick={() => setActive(c)} data-testid={`course-tab-${c.id}`}
              className={`px-5 py-2.5 text-sm rounded-full border transition-colors duration-300 ${active.id === c.id ? "bg-gold text-midnight border-gold" : "border-gold/30 text-white/80 hover:border-gold"}`}>
              {c.name.replace("Professional ", "")}
            </button>
          ))}
        </div>
        <Reveal key={active.id}>
          <div className="grid lg:grid-cols-2 gap-12 items-start glass rounded-xl p-8 sm:p-10 transition-colors duration-500" data-testid={`course-panel-${active.id}`}>
            <div>
              <div className="aspect-[4/3] rounded-lg overflow-hidden border border-gold/20 mb-6"><img src={active.img} alt={active.name} className="w-full h-full object-cover" /></div>
              <div className="flex gap-4 flex-wrap">
                <span className="flex items-center gap-2 text-gold text-sm"><Clock size={16} />{active.duration}</span>
                <span className="flex items-center gap-2 text-gold text-sm"><GraduationCap size={16} />Certification Included</span>
              </div>
              <p className="text-white/60 text-sm mt-4">Course Fee: <span className="text-gold">{active.fee}</span> · Easy EMI available</p>
            </div>
            <div>
              <h3 className="text-3xl tracking-tight">{active.name}</h3>
              <p className="text-white/60 text-sm mt-2 font-label">Curriculum Modules</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 mt-4">
                {active.modules.map((m) => <span key={m} className="flex items-start gap-2 text-white/80 text-sm"><Check size={14} className="text-gold shrink-0 mt-0.5" />{m}</span>)}
              </div>
              <a href="#apply" className="btn-gold inline-flex mt-8" data-testid={`apply-${active.id}`}>Apply for {active.name.replace("Professional ", "")}</a>
            </div>
          </div>
        </Reveal>
      </section>

      <section id="apply" className="py-24 bg-royal/20 border-y border-gold/10">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <SectionTitle label="Admissions Open" title="Apply Now" sub="Fill in your details and our admissions team will call you with fees, batch dates & EMI options." />
          <LeadForm type="enrollments" testid="apply-form" cta="Submit Application"
            extraFields={[{ name: "course", placeholder: "Select Course", type: "select", required: true, options: COURSES.map((c) => c.name) }]} />
        </div>
      </section>
    </>
  );
}
